// extracted by mini-css-extract-plugin
export var shell = "_0-0";